import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { fetchNotPublishedPostsWithPagination } from 'dash-front/campaign/actions/withPagination';
import { getQueries } from 'dash-front/selectors';
import { selectIds } from 'dash-front/selectors/pagination';
import Post from './NotPublishedPost';
import { FINISHED_REQ_DELAY } from 'dash-front/constants';

const FETCH_INTERVAL_SEC = 15;
const PostList = connect((state, { campaignId }) => ({
    isFinished: _.get(getQueries(state), [`GET:not-published/${campaignId}`, 'isFinished']),
    postIds: selectIds(state.pagination, `not-published/${campaignId}`)
}))(
    class _PostList extends React.PureComponent {
        constructor(props, ctx) {
            super(props, ctx);
            this.state = {
                ready: Boolean(props.isFinished)
            };
            this.timer = null;
        }

        componentDidMount() {
            const { dispatch, campaignId } = this.props;
            dispatch(fetchNotPublishedPostsWithPagination(campaignId));
            this.fetchInterval = window.setInterval(() => {
                dispatch(fetchNotPublishedPostsWithPagination(campaignId));
            }, FETCH_INTERVAL_SEC * 1000);
        }

        componentWillReceiveProps({ isFinished, postIds }) {
            if (isFinished !== this.props.isFinished) {
                if (isFinished) {
                    window.clearTimeout(this.timer);
                    this.timer = setTimeout(() => this.setState({ ready: isFinished }), FINISHED_REQ_DELAY);
                } else {
                    window.clearTimeout(this.timer);
                    this.setState({
                        ready: isFinished || Array.isArray(postIds)
                    });
                }
            }
        }

        componentWillUnmount() {
            window.clearInterval(this.fetchInterval);
        }

        render() {
            const { ready } = this.state;
            const { postIds } = this.props;
            const ids = ready && postIds ? postIds : Array(3).fill(null);
            return (
                <div>
                    {ids.length !== 0 && (
                        <div
                            style={{
                                width: '100%',
                                overflowX: 'auto',
                                display: 'flex',
                                padding: '0px 0px 20px 0px'
                            }}
                        >
                            {ids.map((id, index) => (
                                <div key={id || index} style={{ marginLeft: 12 }}>
                                    <Post id={id} />
                                </div>
                            ))}
                        </div>
                    )}
                    {ids.length === 0 && (
                        <div className="empty-message" style={{ margin: 12 }}>
                            Moderation queue is empty.
                        </div>
                    )}
                </div>
            );
        }
    }
);

PostList.propTypes = {
    campaignId: PropTypes.string.isRequired
};

export default PostList;



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/containers/Posts/NotPublishedList.js
 **/